import { useState } from "react";

function InputText({
  labelTitle,
  labelStyle,
  inputName,
  type,
  containerStyle,
  defaultValue,
  placeholder,
  isRequired = false,
  showLabel = true,
  ...rest
}) {
  const [value, setValue] = useState(defaultValue);

  const updateInputValue = (e) => setValue(e);

  return (
    <div className={`form-control w-full ${containerStyle}`}>
      {showLabel && (
        <label className="label mb-1">
          <span className={"text-black font-semibold X" + labelStyle}>
            {labelTitle} {isRequired && <span className="text-red-500">*</span>}
          </span>
        </label>
      )}

      <input
        name={inputName}
        type={type || "text"}
        value={value}
        placeholder={placeholder || ""}
        onChange={(e) => updateInputValue(e.target.value)}
        className="input input-bordered border border-gray-400 w-full text-black bg-white rounded"
        style={type === "date" ? { colorScheme: "light" } : {}}
        {...rest}
      />

    </div>
  );
}

export default InputText;
